module.exports = __webpack_public_path__ + "img/img-5.cb68435f.png";